abstract class CurrentTime {
  get timestamp(): number {
    return this.now.getTime()
  }

  abstract get now(): Date
}

export default CurrentTime
